<p>debug works!</p>
<button (click)="doSilentRefresh()">refresh</button>